export default "__VITE_ASSET__XJ0S6o0S__"